import {
  Grid,
  GridItem,
  Text,
  VStack,
  Checkbox,
  NumberInput,
  NumberInputField,
} from '@chakra-ui/react';

import SelectSearch from 'components/fields/SelectSearch';
import { useAnswerCodes } from '../../hooks';
import { ValidatedField, CurrencyInput } from '..';
import type { CoverageSectionProps } from './types';

const HomeBasedBusinessSection = ({
  coverages,
  updateCoverage,
}: CoverageSectionProps) => {
  const { getOptions, isLoading: isLoadingCodes } = useAnswerCodes();

  return (
    <Grid templateColumns="1fr 1fr" gap={4}>
      <GridItem>
        <Text fontWeight="700" mb={3}>
          Home Based Business
        </Text>
        <VStack align="stretch" spacing={3}>
          <ValidatedField
            itemPath="location"
            fieldPath="coverages.home_based_business_type"
            label="Business Type"
            labelSize="xs"
          >
            <SelectSearch
              options={getOptions('business_description')}
              value={coverages.home_based_business_type || undefined}
              onChange={(value) =>
                updateCoverage(
                  'home_based_business_type',
                  (value as string) || '',
                )
              }
              isLoading={isLoadingCodes}
              allowClear
            />
          </ValidatedField>
          <ValidatedField
            itemPath="location"
            fieldPath="coverages.home_based_business_gross_annual_income"
            label="Gross Annual Income"
            labelSize="xs"
          >
            <CurrencyInput
              value={coverages.home_based_business_gross_annual_income ?? ''}
              onChange={(_, value) =>
                updateCoverage('home_based_business_gross_annual_income', value)
              }
            />
          </ValidatedField>
          <ValidatedField
            itemPath="location"
            fieldPath="coverages.home_based_business_num_employees"
            label="Number of Non-Resident Employees"
            labelSize="xs"
          >
            <NumberInput
              variant="main"
              size="sm"
              min={0}
              value={coverages.home_based_business_num_employees ?? ''}
              onChange={(valueString) =>
                updateCoverage(
                  'home_based_business_num_employees',
                  valueString ? Number(valueString) : null,
                )
              }
            >
              <NumberInputField height={30} placeholder="0" />
            </NumberInput>
          </ValidatedField>
        </VStack>
      </GridItem>
      <GridItem>
        <VStack align="stretch" spacing={2} mt={10}>
          <Checkbox
            isChecked={coverages.home_based_business_products_outside_canada}
            onChange={(e) =>
              updateCoverage(
                'home_based_business_products_outside_canada',
                e.target.checked,
              )
            }
            colorScheme="blue"
          >
            <Text fontSize="sm">Products Sold Outside of Canada</Text>
          </Checkbox>
          <Checkbox
            isChecked={coverages.home_based_business_internet_sales}
            onChange={(e) =>
              updateCoverage(
                'home_based_business_internet_sales',
                e.target.checked,
              )
            }
            colorScheme="blue"
          >
            <Text fontSize="sm">Internet Sales</Text>
          </Checkbox>
          <Checkbox
            isChecked={coverages.home_based_business_professional_activity}
            onChange={(e) =>
              updateCoverage(
                'home_based_business_professional_activity',
                e.target.checked,
              )
            }
            colorScheme="blue"
          >
            <Text fontSize="sm">Professional Activity</Text>
          </Checkbox>
          <Checkbox
            isChecked={coverages.home_based_business_coverage_enabled}
            onChange={(e) =>
              updateCoverage(
                'home_based_business_coverage_enabled',
                e.target.checked,
              )
            }
            colorScheme="blue"
          >
            <Text fontSize="sm">Home-Based Business Coverage</Text>
          </Checkbox>
        </VStack>
      </GridItem>
    </Grid>
  );
};

export default HomeBasedBusinessSection;
